export interface IDisplayInstruction {
  DisplayQty?: number// 1138
  SecondaryDisplayQty?: number// 1082
  InitialDisplayQty?: number// 1608
  DisplayWhen?: string// 1083
  DisplayMethod?: string// 1084
  DisplayLowQty?: number// 1085
  DisplayHighQty?: number// 1086
  DisplayMinIncr?: number// 1087
  RefreshQty?: number// 1088
}
